/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAzureSentinelUpdate extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAzureSentinelUpdate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAzureSentinelUpdate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAzureSentinelUpdate>): BackgroundJobPayloadForPeriodicAzureSentinelUpdate {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAzureSentinelUpdate(), model);
        BackgroundJobPayloadForPeriodicAzureSentinelUpdate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAzureSentinelUpdate>): BackgroundJobPayloadForPeriodicAzureSentinelUpdate {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAzureSentinelUpdate.newInstance(<BackgroundJobPayloadForPeriodicAzureSentinelUpdate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAzureSentinelUpdate) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAzureSentinelUpdate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAzureSentinelUpdate): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAzureSentinelUpdate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
